import { EllipsisVerticalIcon } from 'lucide-react';
import { cn } from '@src/design-system/helpers';
import { buttonVariants } from '@src/design-system/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { useNavigate, useParams } from 'react-router-dom';
import { Dialog, DialogContent } from '@src/design-system/dialog';
import { DeleteConfirmDialog } from '@src/design-system/molecules/delete-confirm-dialog-button';
import { type FC, useState } from 'react';
import ResetPasswordModal from './reset-password-modal';
import type { TUser } from '@shared/types/user';
import memberApi from '@shared/services/member-api';

export const UserActions: FC<{ user: TUser }> = ({ user }) => {
  const [open, setOpen] = useState(false);
  const [openResetPasswordDialog, setOpenResetPasswordDialog] = useState(false);
  const { partnerId } = useParams();
  const navigate = useNavigate();
  const { mutateAsync, isPending } = memberApi.useDelete();

  const handleDeleteUser = () => {
    if (partnerId) {
      mutateAsync({ id: +partnerId }).then(() => {
        navigate('../users');
      });
    }
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          className={cn(
            buttonVariants({ size: 'iconSm', variant: 'primaryOutline' }),
            'border-primary-200'
          )}
        >
          <EllipsisVerticalIcon />
        </DropdownMenuTrigger>

        <DropdownMenuContent align='center'>
          <DropdownMenuItem onClick={() => setOpenResetPasswordDialog(true)}>
            Reset Password
          </DropdownMenuItem>
          <DropdownMenuItem
            className='text-red-600'
            onClick={() => setOpen(true)}
          >
            Delete User
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Dialog
        open={open}
        onOpenChange={setOpen}
      >
        <DialogContent align='center'>
          <DeleteConfirmDialog
            title='Are you sure you want to delete this document?'
            onConfirm={handleDeleteUser}
            isLoading={isPending}
            confirmText='Delete'
            cancelText='Cancel'
            onCancel={() => setOpen(false)}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={openResetPasswordDialog}
        onOpenChange={setOpenResetPasswordDialog}
      >
        <ResetPasswordModal email={user.email || ''} />
      </Dialog>
    </>
  );
};
